import React from 'react'

import moment from 'moment'
import List from 'material-ui/List'
import { connectHits } from 'react-instantsearch/connectors'

import SearchRow from './SearchRow'
import FunctionUtils from '../../lambda/FunctionUtils'

const PREVIOUS_EVENTS_VISIBLE = 2

class SearchHits extends React.PureComponent {

  constructor(props){
    super(props)

    this.state = {
      allInstances: [],
      loading: false
    }
  }

  componentWillMount(){
    if (this.props.hits){
      this.setState({
        loading: true
      })
    }
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.hits !== this.props.hit){
      this.startPipeline(nextProps.hits)
    }
  }

  componentDidUpdate(){
    if (this.scrollAnchor){
      this.scrollAnchor.scrollIntoView()
    }
  }

  startPipeline = (hits) => {

    let allInstances = []
    hits.forEach(hit => {
      const allDateInstances = this.getAllDateInstances(hit)
      allInstances = allInstances.concat(allDateInstances)
    })

    allInstances.sort((a, b) => a.dateTimestamp - b.dateTimestamp)

    //Auto scroll behavior
    const today = moment().format('YYYY-MM-DD')
    const todayTimeStamp = new Date(today).getTime()
    let firstEventToday = 0
    for (let i=0; i<allInstances.length; i++){
      const instance = allInstances[i]
      firstEventToday = i
      const dateTimeStamp = new Date(instance.dateStr).getTime()
      if (dateTimeStamp >= todayTimeStamp){
        break
      }
    }
    this.setState({
      allInstances: allInstances,
      scrollIndex: firstEventToday >= PREVIOUS_EVENTS_VISIBLE ? firstEventToday - PREVIOUS_EVENTS_VISIBLE : firstEventToday,
      loading: false
    })

  }

  getAllDateInstances = (hitObj) => {
    const dateModule = hitObj.dateInfo
    const deletedDateStrs = hitObj.datesDeleted
    let cursor = moment(dateModule.startDate)
    const allDateInstances = []
    while (cursor.isSameOrBefore(dateModule.endDate)) {
      const dateStr = cursor.format('YYYY-MM-DD')

      if (!deletedDateStrs
          || !deletedDateStrs.hasOwnProperty(dateStr)){
        if (!dateModule.recurrence ||
          FunctionUtils.isInsideRecurrence(dateStr, dateModule)) {
          const dateFieldsToAdd = {
            dateStr: dateStr,
            dateTimestamp: (new Date(dateStr).getTime())
          }
          allDateInstances.push(Object.assign({}, hitObj, dateFieldsToAdd))
        }
      }

      cursor.add(1, 'days')
    }
    return allDateInstances
  }

  render() {
    const hits = this.state.allInstances.map((instance, index) => {
      const hit = (
        <SearchRow
          key={`${instance.objectID}-${instance.dateStr}`}
          hit={instance}
          eventId={instance.objectID}
          dateStr={instance.dateStr} />
      )
      if (this.state.scrollIndex === index) {
        return (
          <div
            key={`${instance.objectID}-${instance.dateStr}`}
            ref={(node) => this.scrollAnchor = node}>
            { hit }
          </div>
        )
      }
      return hit
    })

    return (
      <div style={{ display: 'flex', height: '100%', maxHeight: '100%', overflow: 'auto' }}>
        {
          this.state.loading
            ? <div style={{ width:'100%', justifyContent: 'center', alignSelf: 'center', fontSize: 14, color:'rgb(82, 125, 163)' }}>
              Loading Search Results...
            </div>
            : <List style={{ padding: 0, width: '100%' }}>{ hits }</List>
        }
      </div>
    )
  }

}

export default connectHits(SearchHits)



// WEBPACK FOOTER //
// ./src/schedule/search/SearchHits.js